import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ToastrModule } from 'ngx-toastr';
import { filter, Subscription } from 'rxjs';
import { ControlsModule } from 'segov-sigepo-lib';
import { EnviarEmailContatoInputDto } from 'src/app/domain/DTOs/input/enviar-email-contato.input.dto';
import { ToastModel, ToastType } from 'src/app/domain/models/toast.model';
import { enviarEmailContato, enviarEmailContatoFinish } from 'src/app/stateManagement/actions/enviar-email-contato.action';
import { toastShow } from 'src/app/stateManagement/actions/toast.action';

import { EnviarEmailContatoState } from 'src/app/stateManagement/reducers/enviar-email-contato.reducer';
import { ToastState } from 'src/app/stateManagement/reducers/toast.reducer';
import { selectDadosEnviarEmailContato, selectErrosEnviarEmailContato } from 'src/app/stateManagement/selectors/enviar-email-contato.selector';
import { CommonMessages } from 'src/app/utils/common.messages';
import { ToastrMessages } from 'src/app/utils/toastr.messages';
import { emailValidator, minimoCaracteresTelefoneValidator } from 'src/app/utils/validators/abstract-control-common.validator';
import { obterTodosMotivosCombo } from 'src/app/domain/enums/tipo-manifestacao.enum';

@Component({
  selector: 'app-enviar-email-contato',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    ToastrModule,
    ControlsModule
  ],
  templateUrl: './enviar-email-contato.component.html',
  styleUrl: './enviar-email-contato.component.css'
})
export class EnviarEmailContatoComponent implements OnInit, OnDestroy {
  public enviarMensagemForm: FormGroup;
  private subEnviarEmail: Subscription;
  private subEnviarEmailError: Subscription;
  public tiposManifestacao = obterTodosMotivosCombo();

  constructor(
    private readonly storeEnviarEmail: Store<{ enviarEmailContatoState: EnviarEmailContatoState }>,
    private storeToast: Store<{ toastState: ToastState }>,
  ) {
    this.enviarMensagemForm = new FormGroup({
      nome: new FormControl('', [Validators.required, Validators.maxLength(100)]),
      email: new FormControl('', [Validators.required, Validators.maxLength(100), emailValidator]),
      telefone: new FormControl('', [minimoCaracteresTelefoneValidator]),
      tipoManifestacao: new FormControl('', Validators.required),
      mensagem: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(3000)])
    });

    this.subEnviarEmail = new Subscription();
    this.subEnviarEmailError = new Subscription();
  }

  ngOnInit(): void {
    this.subEnviarEmail = this.storeEnviarEmail.select(selectDadosEnviarEmailContato)
      .pipe(filter(state => state !== null))
      .subscribe(result => {
        if (result?.erros.length == 0){
          this.storeToast.dispatch(toastShow({ toastModel: new ToastModel(CommonMessages.Success, ToastrMessages.EmailEnviado, ToastType.Success) }));
          this.enviarMensagemForm.reset();
        }
      });

    this.subEnviarEmailError = this.storeEnviarEmail.select(selectErrosEnviarEmailContato)
      .pipe(filter(state => state !== null))
      .subscribe(erros => {
        erros?.forEach((error: string) => {
          this.storeToast.dispatch(toastShow({ toastModel: new ToastModel(CommonMessages.Alert, error, ToastType.Warning) }));
        });
      });
  }

  ngOnDestroy(): void {
    this.storeEnviarEmail.dispatch(enviarEmailContatoFinish());
    this.subEnviarEmail.unsubscribe();
    this.subEnviarEmailError.unsubscribe();
  }

  private enviarEmail() {
    const enviarEmailContatoInputDto = new EnviarEmailContatoInputDto(
      this.enviarMensagemForm.controls['nome'].value,
      this.enviarMensagemForm.controls['email'].value,
      this.enviarMensagemForm.controls['mensagem'].value,
      this.enviarMensagemForm.controls['telefone'].value,
      this.enviarMensagemForm.controls['tipoManifestacao'].value,
    );

    this.storeEnviarEmail.dispatch(enviarEmailContato({ enviarEmailContatoInputDto }))
  }

  public onSubmit() {
    this.enviarEmail();
  }
}
